import type { OAuthConsentTranslations } from '../interfaces/oauth';

export const oauthTranslations: OAuthConsentTranslations = {
  title: 'Autorizar acceso',
  subtitle: '{{client}} solicita acceso a tu cuenta de {{brand}}.',
  scopeSectionLabel: 'Permisos solicitados',
  scopeMcpDescription:
    'Usar las herramientas MCP de {{brand}} en tu nombre (leer y ejecutar acciones de tu cuenta).',
  loggedInAs: 'Conectado como',
  allowButton: 'Permitir acceso',
  denyButton: 'Denegar',
  deniedTitle: 'Acceso denegado',
  deniedMessage: 'No autorizaste la conexión. No se otorgó ningún acceso.',
  closeWindowHint: 'Ya puedes cerrar esta ventana.',
  invalidRequestTitle: 'Solicitud no válida',
  invalidRequestMessage:
    'Esta solicitud de autorización no es válida o ha expirado. Vuelve a iniciar el proceso desde tu aplicación.',
  backToApp: 'Ir a {{brand}}',
  approveErrorToast: 'No se pudo completar la autorización. Inténtalo de nuevo.',
  loading: 'Cargando solicitud…',
};
